export { default } from './TypeBadge';